/* eslint-disable class-methods-use-this */
/* eslint-disable consistent-return */
import { LatLng, Polyline } from 'leaflet';
import { Point } from 'app/libs/map/drive/Point';
import { TourPointFactory } from 'app/libs/markers/setTourPoint';

const factoryTP = new TourPointFactory();

class ShowTourOnTheMap {
  constructor() {
    this.mainMap = null;
    this.layers = [];
  }

  setMap(map) {
    if (!this.mainMap) this.mainMap = map;
  }

  showPrevTourOnMap(data, map, mapController) {
    this.setMap(map);
    mapController.hideTourPath();
    this.layers = [];
    this.initTourPath(data);
    this.showTourPath(data.id, mapController);
  }

  initTourPath(data) {
    if (data && data.placeData) {
      this.showPlacePoint(data);
    } else if (data.parts) {
      data.parts.forEach((el) => {
        this.initPolyline(el);
        this.initTourPoints(el, data.id);
      });
    }
  }

  showTourPath(id, mapController) {
    if (!this.layers || this.layers.length === 0) return;
    mapController.showTourPath(this.layers);
  }

  initPolyline(data) {
    if (!data || !data.poly) return;

    const polyline = new Polyline(this.strToLanLngArray(data.poly), {
      opacity: this.mainMap.getZoom() > 10 ? 0.6 : 1,
      weight: 6,
      color: '#652C95',
    });
    this.layers.push(polyline);
  }

  initTourPoints(data, tourId) {
    if (!data || !data.points || data.points.length < 2) return;

    const activeStartPoint = this.getStartPoint(data.points, tourId);
    if (activeStartPoint) {
      activeStartPoint.click = (el) =>
        console.log(`/tour/public/tour_${el.getId()}`);
      this.layers.unshift(activeStartPoint.getMarker());
    }

    const endPoint = this.getEndPoint(data.points);
    if (endPoint) this.layers.unshift(endPoint.getMarker());
  }

  getEndPoint(points) {
    if (!points.length) return;
    const end_point = points[points.length - 1];
    return factoryTP.createPoint({
      map: this.mainMap,
      pointType: Point.Type.END,
      lat: end_point.lat ? end_point.lat : end_point[0],
      lng: end_point.lng ? end_point.lng : end_point[1],
    });
  }

  getStartPoint(points, tourId) {
    if (!points.length) return;
    const start_point = points[0];
    return factoryTP.createPoint({
      map: this.mainMap,
      pointType: Point.Type.START,
      lat: start_point.lat ? start_point.lat : start_point[0],
      lng: start_point.lng ? start_point.lng : start_point[1],
      tourId,
    });
  }

  showPlacePoint(data) {
    const { placeData = {} } = data;
    const placePoint = factoryTP.createPoint({
      map: this.mainMap,
      pointType: Point.Type.PLACE,
      lat: placeData.lat,
      lng: placeData.lng,
      data: placeData,
      tourId: placeData.id,
    });
    placePoint.setZIndex(999);
    this.layers.unshift(placePoint.getMarker());
  }

  strToLanLngArray(string) {
    if (!string) return [];
    const tourPathArr = string.split('|');
    const GlatLngArr = [];
    tourPathArr.forEach((item) => {
      const lat_lng = item.split(',');
      if (lat_lng.lenght < 2 || !lat_lng[0] || !lat_lng[1]) return;
      GlatLngArr.push(new LatLng(lat_lng[0], lat_lng[1]));
    });
    return GlatLngArr;
  }
}

export const mapTourPoly = new ShowTourOnTheMap();
